import React from 'react';
import { getRecentSearches } from '../utils/localStorage';

const RecentSearches = ({ onSelectSearch }) => {
  const [searches, setSearches] = React.useState([]);

  React.useEffect(() => {
    const recent = getRecentSearches();
    setSearches(recent);
  }, []);

  if (searches.length === 0) {
    return null;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="mb-3">
      <h6 className="text-muted mb-2">
        <i className="bi bi-clock-history me-2"></i>
        Recent Searches
      </h6>
      <div className="d-flex flex-wrap gap-2">
        {searches.map((search, index) => (
          <button
            key={index}
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onSelectSearch(search.from, search.to, new Date(search.date))}
            title={`${search.from} → ${search.to} on ${formatDate(search.date)}`}
          >
            {search.from.split('(')[0].trim()} → {search.to.split('(')[0].trim()}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecentSearches;

